import { UrlEventType, UrlParameter } from 'src/requester';
import {
  BrowserType,
  BrowserIndexMap,
  StaticDataType,
  DeviceType,
  OperatingSystemType,
  OperatingSystemIndexMap,
} from './types';

/**
 * @class
 * StaticData - a class for creating static data for Kameleoon.
 * */
export class StaticData {
  private browserType?: BrowserType;
  private browserVersion?: number;
  private visitNumber?: number;
  private timeSincePreviousVisit?: number;
  private deviceType?: DeviceType;
  private os?: OperatingSystemType;

  constructor({
    browserType,
    visitNumber,
    timeSincePreviousVisit,
    os,
    deviceType,
    browserVersion,
  }: StaticDataType) {
    this.browserType = browserType;
    this.visitNumber = visitNumber;
    this.timeSincePreviousVisit = timeSincePreviousVisit;
    this.os = os;
    this.deviceType = deviceType;
    this.browserVersion = browserVersion;
  }

  get url(): string {
    const browserVersion = this.browserVersion
      ? UrlParameter.BrowserVersion + this.browserVersion
      : '';
    const browserType = this.browserType
      ? UrlParameter.Browser + this.browserType
      : '';
    const browserIndex = this.browserType
      ? UrlParameter.BrowserIndex + BrowserIndexMap[this.browserType]
      : '';
    const os = this.os ? UrlParameter.Os + this.os : '';
    const osIndex = this.os
      ? UrlParameter.OsIndex + OperatingSystemIndexMap[this.os]
      : '';
    const deviceType = this.deviceType
      ? UrlParameter.DeviceType + this.deviceType
      : '';
    const visitNumber =
      this.visitNumber !== undefined
        ? UrlParameter.VisitNumber + this.visitNumber
        : '';
    const timeSincePreviousVisit =
      this.timeSincePreviousVisit !== undefined
        ? UrlParameter.TimeSincePreviousVisit + this.timeSincePreviousVisit
        : '';

    return (
      UrlEventType.StaticData +
      browserType +
      browserIndex +
      browserVersion +
      visitNumber +
      timeSincePreviousVisit +
      os +
      osIndex +
      deviceType
    );
  }
}
